module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "o-filter-options o-filter-options__box flex-grid flex-grid--reduced-bottom-margin a-form-inputs flex-grid--wrap"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "flex-grid__item--third-label"
  }, [_vm._v("Claim Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.claimType),
      expression: "claimType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.claimType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fatal_accident"
    }
  }, [_vm._v("All Fatal Accident")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fatal_accident_dependency"
    }
  }, [_vm._v("Fatal Accident Dependency")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fatal_accident_estate"
    }
  }, [_vm._v("Fatal Accident Estate")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "lost_years"
    }
  }, [_vm._v("Lost Years")]), _vm._v(" "), (_vm.diseaseOrAccident !== 'disease') ? _c('option', {
    attrs: {
      "value": "personal_injury"
    }
  }, [_vm._v("Personal Injury")]) : _vm._e()])]), _vm._v(" "), (_vm.claimType !== 'personal_injury') ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "flex-grid__item--third-label"
  }, [_vm._v("Disease or Accident")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.diseaseOrAccident),
      expression: "diseaseOrAccident"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.diseaseOrAccident = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "disease"
    }
  }, [_vm._v("Disease")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "accident"
    }
  }, [_vm._v("Accident")])])]) : _vm._e(), _vm._v(" "), (_vm.diseaseOrAccident === 'disease') ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "flex-grid__item--third-label"
  }, [_vm._v("Disease Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.diseaseType),
      expression: "diseaseType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.diseaseType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asbestos Related Lung Cancer"
    }
  }, [_vm._v("Asbestos Related Lung Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Bladder Cancer"
    }
  }, [_vm._v("Bladder Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Kidney Cancer"
    }
  }, [_vm._v("Kidney Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Laryngeal Cancer"
    }
  }, [_vm._v("Laryngeal Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Leukemia"
    }
  }, [_vm._v("Leukemia")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Liver Cancer"
    }
  }, [_vm._v("Liver Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Mesothelioma"
    }
  }, [_vm._v("Mesothelioma")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Nasal Cancer"
    }
  }, [_vm._v("Nasal Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other"
    }
  }, [_vm._v("Other")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other Cancer"
    }
  }, [_vm._v("Other Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Skin Cancer"
    }
  }, [_vm._v("Skin Cancer")])])]) : _vm._e(), _vm._v(" "), (_vm.diseaseOrAccident === 'accident' || _vm.claimType === 'personal_injury') ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "flex-grid__item--third-label"
  }, [_vm._v("Accident Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accidentType),
      expression: "accidentType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.accidentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Accident - EL"
    }
  }, [_vm._v("Accident - EL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Accident - PL"
    }
  }, [_vm._v("Accident - PL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Motor"
    }
  }, [_vm._v("Motor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other"
    }
  }, [_vm._v("Other")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "flex-grid__item--third-label"
  }, [_vm._v("Discount Rate")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discountRate),
      expression: "discountRate"
    }],
    attrs: {
      "name": "discount_rate",
      "id": "discount_rate"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discountRate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -2.0
    }
  }, [_vm._v("-2.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -1.5
    }
  }, [_vm._v("-1.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -1.0
    }
  }, [_vm._v("-1.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.75
    }
  }, [_vm._v("-0.75%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.5
    }
  }, [_vm._v("-0.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.25
    }
  }, [_vm._v("-0.25%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0.0
    }
  }, [_vm._v("0.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0.5
    }
  }, [_vm._v("0.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1.0
    }
  }, [_vm._v("1.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1.5
    }
  }, [_vm._v("1.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2.0
    }
  }, [_vm._v("2.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2.5
    }
  }, [_vm._v("2.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3.0
    }
  }, [_vm._v("3.00%")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('from-to')], 1)]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small p-compare-reserve__top-form-button",
    on: {
      "click": _vm.calculate
    }
  }, [_vm._v("Load Claims")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-52a86b5e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/compare/components/Form.vue
// module id = 1690
// module chunks = 0